export const aging = {
   id: "aging",
   title: "Aging",
   family: "aging",
   endpoint: "/runaging.sz",
   defaultSort: { key: "remaining", dir: "desc" },
   groupBy: ["age_bucket"],
   groupOptions: [
      { value: "age_bucket", label: "Age bucket" },
      { value: "supplier",   label: "Supplier" },
      { value: "location",   label: "Location" },
   ],
   categoryField: "age_bucket",
   categoryLabel: "Age bucket",
   minField: "remaining",
   minLabel: "Min outstanding $",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
      { key: "suppliers", type: "multiselect", label: "Suppliers" },
      { key: "minVariance", type: "number", label: "Min $" },
   ],
   summary: [
      { key: "lines",       label: "Lines",         type: "int",   agg: "count" },
      { key: "outstanding", label: "$ Outstanding", type: "money", agg: "sum", column: "remaining" },
      { key: "over90",      label: "Over 90 days",  type: "int",   agg: "countWhere", column: "age_bucket", equals: "90+ days" },
   ],
   columns: [
      { key: "supplier",         label: "Supplier",   type: "text",  align: "left" },
      { key: "location",         label: "Location",   type: "text",  align: "left" },
      { key: "invoice_no",       label: "Invoice #",  type: "text",  align: "left",  drill: "pair" },
      { key: "statement_date",   label: "Statement date", type: "date",  align: "left" },
      { key: "statement_amount", label: "Statement $", type: "money", align: "right", total: "sum" },
      { key: "allocated",        label: "Allocated $", type: "money", align: "right", total: "sum" },
      { key: "remaining",        label: "Remaining $", type: "money", align: "right", total: "sum", accent: true },
      { key: "age_days",         label: "Age (days)", type: "int",   align: "right" },
      { key: "age_bucket",       label: "Bucket",     type: "label", align: "left" },
   ],
};
